import { GlobalConstants } from "../../../common/constants/global.constant";

export const graphicsModelsConstant = [
  {
    name: GlobalConstants.INTEL_ARC_DEDICATED_GRAPHICS_MOB,
    nameInEng: 'Intel(R) Arc(TM) A-Series Mobile GPU'
  },
  {
    name: GlobalConstants.INTEL_ARC_DEDICATED_GRAPHICS_DEKTOP,
    nameInEng: 'Intel(R) Arc(TM) A-Series Desktop GPU'
  },
  {
    name: GlobalConstants.INTEL_ARC_PROCESSOR_GRAPHICS_FOR_MOBILE,
    nameInEng: 'Build-in Intel(R) Arc(TM) GPU'
  },
  {
    name: GlobalConstants.INTEL_ARC_PRO_MOBILE_GRAPHICS,
    nameInEng: 'Intel® Arc™ Pro Graphics for Mobile'
  },
  {
    name: GlobalConstants.INTEL_ARC_PRO_DESK_GRAPHICS,
    nameInEng: 'Intel® Arc™ Pro Graphics for Desktop'
  },
  {
    name: GlobalConstants.INTEL_IRIS_ARC_XE_GRAPHICS,
    nameInEng: 'Intel® Iris® Xe Graphics'
  },
  {
    name: GlobalConstants.INTEL_IRIS_ARC_XEMAX_DEDICATED_GRAPHICS,
    nameInEng: 'Intel® Iris® Xe Max Dedicated Graphics'
  },
  {
    name: GlobalConstants.INTEL_IRIS_PLUS_GRAPHICS,
    nameInEng: 'Intel® Iris® Plus Graphics'
  },
  {
    name: GlobalConstants.INTEL_UHD_GRAPHICS,
    nameInEng: 'Intel® UHD Graphics'
  },
  {
    name: GlobalConstants.INTEL_GRAPHICS,
    nameInEng: 'Intel® Graphics'
  },
  {
    name: GlobalConstants.AMD_RADEON,
    nameInEng: 'AMD* Radeon*'
  },
  {
    name: GlobalConstants.AMD_RADEON_RX_6000_SERIES,
    nameInEng: 'AMD* Radeon* RX 6000 Series'
  },
  {
    name: GlobalConstants.AMD_RADEON_RX_6000M_SERIES,
    nameInEng: 'AMD* Radeon* RX 6000M Series'
  },
  {
    name: GlobalConstants.AMD_RADEON_RX_7000_SERIES,
    nameInEng: 'AMD* Radeon* RX 7000 Series'
  },
  {
    name: GlobalConstants.NVIDIA_GEFORCE_GTX_16_SERIES,
    nameInEng: 'NVIDIA* GeForce* GTX 16 Series'
  },
  {
    name: GlobalConstants.NVIDIA_GEFORCE_RTX_30_SERIES,
    nameInEng: 'NVIDIA* GeForce* RTX 30 Series'
  },
  {
    name: GlobalConstants.NVIDIA_GEFORCE_RTX_20_SERIES,
    nameInEng: 'NVIDIA* GeForce* RTX 20 Series'
  },
  {
    name: GlobalConstants.NVIDIA_GEFORCE_RTX_40_SERIES,
    nameInEng: 'NVIDIA* GeForce* RTX 40 Series'
  }
]